const state = () => {
  return {
    isActive: false
  }
}

const actions = {
  showAlert:  function({ state, commit }, { vc, message }) {
    if(!state.isActive) {
      commit('disable')
      vc.$q.dialog({
        title: '알림',
        message: message
      }).onOk(() => {
        // console.log('OK')
        commit('disable')
      }).onCancel(() => {
        // console.log('Cancel')
        commit('disable')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }
  },
  showError: function(_,{vc, message }) {
    vc.$q.notify({
      position: 'top',
      color: 'negative',
      icon: 'error_outline',
      timeout: 3000,
      message: message
    })
  },
  showMessage: function(_,{vc, message }) {
    vc.$q.notify({
      position: 'top',
      icon: 'notification_important',
      timeout: 3000,
      message: message
    })
  }
}

const mutations = {
  active (state) {
    state.isActive = true
  },
  disable (state) {
    state.isActive = false
  }
}

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations
}
